module.exports = __webpack_public_path__ + "img/apetit.82bcb293.jpg";